module.exports = __webpack_public_path__ + "static/media/36-9.dbc3fda4.mp3";